import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
@Component({
  selector: 'app-sign-in',
  standalone: true,
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss',
})
export class SignInComponent implements OnInit {

  ngOnInit(): void {
    // window.location.href = environment.pingfedAuthUrl;
    // window.location.href = 'https://iapi-test.merck.com/authentication-service/v2/authorize?response_type=token&client_id=asv2-43926117-e50b-4520-8c7f-cd91ff4&scope=default&redirect_uri=http://localhost:4200/verify-token&login_method=sso';
    window.location.href ='https://iapi-test.merck.com/authentication-service/v2/authorize?response_type=token&client_id=asv2-f3be0229-f88c-4091-87cc-5462141&scope=default&redirect_uri=https://tbt-ussc-dev.healtheq.com/verify-token&login_method=sso'
  }

}
